import * as yup from 'yup'
import css from '../../../ComplaintForm/ComplaintForm.module.css'

import { victimAgeMessage, maxAgeMessage } from '../../../../strings/messages'

export const childrenPage = (fieldOverrides, pageOverrides) => {
  const page = {
    id: 'children_age',
    ...pageOverrides
  }
  const field = {
    name: 'children',
    label: 'How old is the child?',
    labelClassName: css.largeLabel,
    hint: `You'll be able to include up to five children`,
    max: 5,
    maxAge: 50,
    ...fieldOverrides
  }

  const validation = yup.object().shape({
    [field.name]: yup.array().of(
      yup.object().shape({
        age: yup
          .number()
          .typeError(victimAgeMessage)
          .integer(maxAgeMessage)
          .positive(maxAgeMessage)
          .max(field.maxAge, maxAgeMessage)
          .required(victimAgeMessage)
      })
    )
  })

  return {
    ...page,
    fields: [
      {
        ...field,
        type: 'repeatable',
        fields: [
          {
            type: 'number',
            name: 'age',
            label: 'Child age',
            max: field.maxAge
          }
        ],
        addButton: {
          variation: 'transparent',
          text: '+ Add another child'
        }
      }
    ],
    validation
  }
}
